import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Loading from "../../../shared/ui/Loading";
import React, {useEffect} from "react";
import Profile from "../../userProfile/pages/Profile";
import useIsLoggedIn from "../../../hooks/useIsLoggedIn";
import {useNavigate, useSearchParams} from "react-router-dom";
import {APIGetEmailVerify} from "../api/login";
import {useAuth} from "../../../hooks/useAuth";

const EmailVerifyFromProfile = () => {
    const {update} = useAuth();
    const isLoggedIn = useIsLoggedIn();
    const [loading, setLoading] = React.useState<boolean>(true);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const url = searchParams.get("verify_url");

    const handleSuccessNotification = (message: string) => {
        update("error", {
            show: true,
            icon: "fat envelope",
            closable: true,
            title: message,
            // message: message,
            button: "ÎNCHIDE",
            returnFunction: () => {
                navigate(isLoggedIn ? "/profil" : "/");
            },
        });
    };

    const showExpirationError = (message: string, tenant: string, user: number) => {
        update("error", {
            show: true,
            title: message,
            // message: message,
            button: "ÎNCHIDE",
            icon: "fat face-eyes-xmarks",
            closable: true,
        });
    }

    useEffect(() => {
        if (!url) {
            window.location.replace("/");
            return;
        }

        setLoading(true);

        APIGetEmailVerify(url)
            .then((response) => {
                if (response.data.success) {
                    update("user", {emailNotifications: true});
                    handleSuccessNotification(response.data.data.message);
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                if (err.response.status === 410) {
                    const { message, tenant: tId, user: uId } = err.response.data.data;
                    showExpirationError(message, tId, uId);
                } else {
                    update("error", {show: true, code: "A001",});
                }
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isLoggedIn && <Profile />}
            <Box component="main">
                <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="stretch" mt={0}>
                    {loading && <Loading modal={true} show={true}/>}
                </Grid>
            </Box>
        </>

    );
};

export default EmailVerifyFromProfile;